// extracted by mini-css-extract-plugin
export default {"section_no_background":"testimonial_section_no_background__ox1TY","centered_block":"testimonial_centered_block__pezj2"};